import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

import LoginStyles from "views/open/Login.module.scss";
import { LoginForm } from "components/login/LoginForm";

export const Login = () => {
  return (
    <div id={"gb-open"}>
      <Helmet>
        <title>Minha Glambox : Login</title>
      </Helmet>
      <div className={LoginStyles["login"]}>
        <div className={LoginStyles["login__info"]}>
          <h5 className={"text-uppercase"}>
            Bem Vinda!
          </h5>
          <p className={"text-center"}>Receba as últimas novidades sobre beleza e bem-estar, além de promoções exclusivas e sorteios.</p>
          <p className={"text-center"}>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdHC0-PS3sahJlMcWPCZpJssE1YvufCqsTjy2nuCC1uOQYmKA/viewform" className={"btn btn-sm btn-outline-white"}>
              Registrar-se
            </a>
          </p>
        </div>
        <div className={LoginStyles["login__form"]}>
          <h5 className={"text-center"}>Já é cadastrada?</h5>

          <LoginForm/>
        </div>
      </div>
    </div>
  );
};
